import React from 'react';
import { portfolio } from '../data/mock';

const PortfolioCard = ({ item }) => {
  // Determine badge color based on category
  const getBadgeColor = (category) => {
    switch (category) {
      case 'Business Branding':
        return 'bg-cyan-500';
      case 'Custom Design':
        return 'bg-cyan-600';
      case 'Premium Wrap':
        return 'bg-amber-500';
      case 'Anti Graffiti Film':
        return 'bg-rose-500';
      case 'Removals':
        return 'bg-emerald-500';
      default:
        return 'bg-cyan-500';
    }
  };

  return (
    <div className="group relative rounded-xl overflow-hidden cursor-pointer">
      {/* Image */}
      <div className="aspect-[4/3] overflow-hidden">
        <img
          src={item.image}
          alt={`${item.title} — ${item.category} project completed by WrapAlot Specialty Filmz, Sacramento CA`}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/20 to-transparent" />

      {/* Content */}
      <div className="absolute bottom-0 left-0 right-0 p-5">
        <span className={`inline-block ${getBadgeColor(item.category)} text-white text-xs font-semibold px-3 py-1 rounded-full mb-2`}>
          {item.category}
        </span>
        <h3 className="text-lg font-bold text-white">
          {item.title}
        </h3>
      </div>

      {/* Hover effect */}
      <div className="absolute inset-0 bg-cyan-500/0 group-hover:bg-cyan-500/10 transition-colors duration-300" />
    </div>
  );
};

const Portfolio = () => {
  return (
    <section id="portfolio" className="bg-slate-800 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Our Work
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Quality craftsmanship and attention to detail in every project
          </p>
        </div>

        {/* Portfolio Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {portfolio.map((item) => (
            <PortfolioCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
